import React, { Component } from 'react';
import './Policies.css';

export default class PoliciesPage extends Component {
  render() {
    return (
      <section className='policy'>
        <h3>It Takes a Village Policies and Terms and Conditions</h3>
        <div className='paraContainer'>
          <p>
            The information contained in this Application is provided for
            informational purposes only, any and all usage is at the sole
            discretion of the user. No recipients of content from this
            Application or otherwise, should act or refrain from acting on the
            basis of any content included in the Application without seeking the
            appropriate legal or other professional advice on the particular
            facts and circumstances at issue from an attorney licensed in the
            recipient's state. The content of this Application contains general
            information and may not reflect current legal developments. This
            Application disclaims all liability in respect to actions taken or
            not taken based on any or all the contents of this Application. Any
            information sent through the Application is secured by the
            developers best ability, however due to the nature of continually
            evolving security risk, Any and all information transmitted is done
            so on a non-confidential basis. Transmission of information from
            this Application does not create an attorney-client relationship
            between you and Application, nor is it intended to do so. The
            transmission of the Application, in part or in whole, and/or any
            communication with us via Internet e-mail through this site does not
            constitute or create an attorney-client relationship between us and
            any recipients. Some features within the Application may utilize
            third parties application programming interface henceforth known and
            referred to as an API. The Application includes these features
            solely as a convenience to you, and the presence of such an API does
            not imply a responsibility for the API or an endorsement of the API,
            or its contents. Furthermore, This Application does not wish to
            represent anyone desiring representation based upon viewing this
            Application in a state where this Application fails to comply with
            all laws and ethical rules of that state. Reproduction,
            distribution, republication, and/or retransmission of material
            contained within this Application is prohibited unless the prior
            written permission of the developer has been obtained.
          </p>
        </div>
      </section>
    );
  }
}
